import * as THREE from 'three';

/**
 * 特征预览描边材质工厂。
 *
 * 文件定位：
 * 1. 当前文件位于 cad-core 的 material 目录，属于材质封装层；
 * 2. 它专门负责拉伸等三维特征预览体的描边材质；
 * 3. 预览描边只承担显示职责，不参与正式实体交互状态，因此必须与正式 FeatureLine 材质解耦。
 */
export class FeaturePreviewLineMaterialFactory {
  /** 预览描边颜色。 */
  private static readonly PREVIEW_LINE_COLOR = 0xffff00;

  /** 预览描边单例材质。 */
  private static previewLineMaterial: THREE.LineBasicMaterial | null = null;

  /**
   * 获取预览描边材质。
   *
   * 说明：
   * 1. 预览描边只承担显示职责，关闭深度测试后必须同步关闭深度写入，
   *    避免描边像素写入深度缓冲后干扰后绘制的实体面与透明预览体；
   * 2. 等距实体预览同样复用该材质，关闭深度写入是"前景覆盖"语义的收口前提。
   *
   * @returns 预览描边材质。
   */
  public static getMaterial(): THREE.LineBasicMaterial {
    if (!FeaturePreviewLineMaterialFactory.previewLineMaterial) {
      FeaturePreviewLineMaterialFactory.previewLineMaterial = new THREE.LineBasicMaterial({
        color: FeaturePreviewLineMaterialFactory.PREVIEW_LINE_COLOR,
        transparent: false,
        opacity: 1,
        depthTest: false,
        depthWrite: false,
      });
      FeaturePreviewLineMaterialFactory.previewLineMaterial.name = '特征预览描边材质';
    }

    return FeaturePreviewLineMaterialFactory.previewLineMaterial;
  }
}
